const MODAL_ANIMATION_DURATION = 400;

const ENV = window.location.hostname === 'login-homologacao.aqila.com.br' ? 'homologation' : process.env.NODE_ENV;

export {
  MODAL_ANIMATION_DURATION,
  ENV,
};
